export { RENDERER_TYPE, baseRenderer } from "./baseRenderer.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/renderers/baseRenderer/index.mjs
// module id = 270
// module chunks = 1